import { render, staticRenderFns } from "./VenezuelanGovernment.vue?vue&type=template&id=3a768e71&"
import script from "./VenezuelanGovernment.vue?vue&type=script&lang=js&"
export * from "./VenezuelanGovernment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports